exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-0e9ff088] .el-form-item{margin-bottom:10px}", ""]);

// exports
